import {IFileEntryState, initialFileEntryState} from '@app/core/store/state/file-entry.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {EFileEntryActions, FileEntryActions} from '@app/core/store/actions/file-entry.actions';

export const fileEntryReducers = (
	state = initialFileEntryState,
	action: FileEntryActions | ErrorActions,
): IFileEntryState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		case EFileEntryActions.PostFileEntriesSuccess: {
			return {
				...state,
				uploadedFiles: [...state.uploadedFiles, ...action.fileEntries]
			};
		}

		case EFileEntryActions.GetFileEntrySuccess: {
			return {
				...state,
				fileEntries: [action.fileEntry, ...state.fileEntries]
			};
		}
		case EFileEntryActions.RemoveFileEntry: {
			return {
				...state,
				uploadedFiles: state.uploadedFiles.filter(up => up.id !== action.fileEntry.id)
			};
		}

		case EFileEntryActions.AddFileEntries: {
			return {
				...state,
				uploadedFiles: action.fileEntries
			};
		}
		case EFileEntryActions.ClearFileEntries: {
			return {
				...state,
				fileEntries: [],
				uploadedFiles: [],
			};
		}
		case EFileEntryActions.GetFileEntries: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EFileEntryActions.GetFileEntriesSuccess: {
			return {
				...state,
				isLoading: false,
				fileEntries: action.files,
				pagination: action.pagination,
			};
		}
		default:
			return state;
	}
};
